import { Chip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export const getColor = (status) => {
  console.log(status);

  if (status === "rejected") {
    return "error";
  } else if (status === "approved") {
    return "success";
  } else if (status === "pending") {
    return "info";
  } else if (status === "queued") {
    return "warning";
  } else if (status === "complete") {
    return "success";
  } else if (status === "error") {
    return "error";
  } else if (status === "Abnormal Request") {
    return "error";
  } else if (status === "not-required") {
    return "warning";
  } else if (status === "active") {
    return "success";
  } else {
    return "secondary";
  }
};

const getStatusStyles = (status) => {
  // text-[10px] for micro-size text
  const baseClasses =
    "px-2 py-0.5 rounded-full !text-[11px] font-extrabold uppercase tracking-tighter inline-flex items-center justify-center leading-none min-h-[18px]";

  switch (status?.toLowerCase()) {
    case "rejected":
    case "error":
    case "abnormal request":
      return `${baseClasses} bg-red-100 !text-red-600 border border-red-200`;
    case "approved":
    case "complete":
    case "success":
    case "active":
      return `${baseClasses} bg-green-100 !text-green-600 border border-green-200`;
    case "pending":
      return `${baseClasses} bg-blue-100 !text-blue-600 border border-blue-200`;
    case "queued":
    case "not-required":
      return `${baseClasses} bg-yellow-100 !text-yellow-700 border border-yellow-200`;
    default:
      return `${baseClasses} bg-gray-100 !text-gray-600 border border-gray-200`;
  }
};

function ResponseDetailsComponentNew({ item }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  function formatDateTime(data) {
    const date = new Date(data);
    // Get date components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding padding if needed
    const day = String(date.getDate()).padStart(2, "0"); // Adding padding if needed

    // Get time components
    const hours = String(date.getHours()).padStart(2, "0"); // Adding padding if needed
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Adding padding if needed
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Adding padding if needed

    // Construct the date and time string in the format "YYYY-MM-DD HH:MM:SS"
    const dateTimeString = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

    return dateTimeString;
  }

  const fields = [
    // Line 1 as requested
    { label: "Beneficiary Name", value: item?.patient_name },
    { label: "Document", value: item?.patient_document_id },
    { label: "Disposition", value: item?.disposition },
    { label: "Is Referral", value: item?.is_referral, type: "switch" },
    { label: "Is Follow Up", value: item?.is_followup_req, type: "switch" },
    { label: "Is New Born", value: item?.is_new_born, type: "switch" },
    {
      label: "Transaction Date",
      value: item?.transaction_date
        ? formatDateTime(item?.transaction_date)
        : null,
    },
    {
      label: "Date Ordered",
      value: item?.date_ordered ? formatDateTime(item?.date_ordered) : null,
    },
    { label: "Type", value: item?.type },

    // Line 2 as requested + remaining elements
    { label: "Sub Type", value: item?.subtype },
    { label: "Offline Eligibility Id", value: item?.offline_verification_id },
    {
      label: "Offline Eligibility Date",
      value: item?.offline_verification_date,
    },
    { label: "Cancellation Status", value: item?.calcellation_status },
    { label: "Outcome", value: item?.outcome, type: "status" },
    { label: "Status", value: item?.status, type: "status" },

    { label: "Ref Transaction ID", value: item?.followup_ref_transaction_id },

    {
      label: "Cancellation Status Reason",
      value: item?.calcellation_status_reason,
    },
    { label: "Pre Auth Ref. No.", value: item?.pre_auth_ref_no },
    { label: "Pre Auth Res. Identifier", value: item?.pre_auth_ref_value },

    { label: "Pre Auth Period", value: item?.pre_auth_period },
    { label: "Pre Auth Res. Url", value: item?.pre_auth_ref_url },
    {
      label: "Related Pre Auth Request Identifier",
      value: item?.related_pre_auth_req_identifier,
    },

    {
      label: "Eligibility Response Identifier (Value)",
      value: item?.verification_resp_ident_value,
    },
    {
      label: "Eligibility Response Identifier (Url)",
      value: item?.verification_resp_ident_url,
    },
    { label: "Insurer", value: item?.payer_name },
    { label: "TPA Name", value: item?.tpa_name },
    {
      label: "Related Pre Auth Ref. No.",
      value: item?.related_pre_auth_ref_no,
    },
  ];

  return (
    <div className="eligibility_details_section" dir={isRTL ? "rtl" : "ltr"}>
      {/* Header matching the style requested (light gray bg) */}
      <div className="bg-gray-100 flex justify-between items-center px-2 py-1 border-b border-gray-200 print:!bg-transparent print:!border-gray-300">
        <div className="flex flex-col">
          <span className="font-bold text-[14px] text-gray-700 uppercase tracking-wide print:!text-black">
            {t("PreAuth Response")}
          </span>
        </div>
      </div>
      {item?.validation_errors?.length > 0 && (
        <div className="border-b border-yellow-300 bg-yellow-50 px-2 py-1">
          <div className="flex items-center gap-1 mb-1">
            <span className="text-yellow-700 text-[13px] font-bold uppercase tracking-tight">Validation Errors</span>
          </div>
          {item?.validation_errors?.map((ve, veIdx) => (
            <div key={veIdx} className="mb-1">
              {ve.error_date && (
                <span className="text-[13px] text-yellow-600 font-semibold">
                  {formatDateTime(ve?.error_date)}
                </span>
              )}
              {ve?.errors?.map((err, errIdx) => (
                <div key={errIdx} className="flex items-start gap-1 py-0.5 text-[13px] leading-tight">
                  <span className="font-bold text-yellow-800 whitespace-nowrap">{err.error_code}:</span>
                  <span className="text-yellow-700">{err.error_message}</span>
                  {err.value_string && (
                    <span className="text-yellow-500 text-[13px] break-all">({err.value_string})</span>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-7 gap-x-2 gap-y-3 p-3 bg-white">
        {fields.map((field, idx) => (
          <div key={idx} className="eligibility_details_user_data col-span-1">
            <div
              className={`data_head !mb-0.5 ${isRTL ? "!text-right" : "!text-left"
                }`}
            >
              <span className="!text-gray-500 !text-[12px] font-semibold uppercase tracking-tight">
                {t(field.label)}
              </span>
            </div>
            <div
              className={`data_cont mt-0.5 leading-tight ${isRTL ? "!text-right" : "!text-left"}`}
            >
              {field.type === "switch" ? (
                <label className="switch transform scale-[0.6] origin-left -ml-1 inline-block">
                  <input
                    type="checkbox"
                    checked={field.value || false}
                    disabled
                    className="peer"
                  />
                  <span className="slider peer-checked:!bg-[#0070C2]"></span>
                </label>
              ) : field.type === "status" ? (
                <div className="mt-0.5 flex items-center h-[20px]">
                  {field.value ? (
                    <span className={getStatusStyles(field.value)}>
                      {t(field.value)}
                    </span>
                  ) : (
                    <span className="!text-gray-400 !text-[11px]">___</span>
                  )}
                </div>
              ) : (
                <span
                  className={`!text-[11px] !font-bold break-words ${field.label === "Site Eligibility" ? "!text-green-700" : "!text-[#0070C2]"}`}
                >
                  {field.value || <span className="!text-gray-400">___</span>}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ResponseDetailsComponentNew;
